import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import profile from "../../../../images/profile.jpeg";
export const ConnectedAccount = ({
  onClickDisconnect,
  address,
  isValidNetwork,
}) => {
  
  var truncate = function (fullStr, strLen, separator) {
    if (fullStr.length <= strLen) return fullStr;

    separator = separator || "...";

    var sepLen = separator.length,
      charsToShow = strLen - sepLen,
      frontChars = Math.ceil(charsToShow / 2),
      backChars = Math.floor(charsToShow / 2);

    return (
      fullStr.substr(0, frontChars) +
      separator +
      fullStr.substr(fullStr.length - backChars)
    );
  };


  return (
    <aside className="profile-block primary-btn">
      
      <Button variant="contained" onClick={onClickDisconnect}>
        <p>
          <span className="profile-id">
            <img src={profile} />

            <span className="ethereum-num">
              <span
                className={`profile-name ${isValidNetwork ? "connected" : ""}`}
              >
                {isValidNetwork ? "Connected" : "Invalid Network"}
              </span>
              {/* <span className="profile-name connected"> Connected </span> */}
              <span className="eth-icon-text">
                <i>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 48 48"
                    width="48px"
                    height="48px"
                  >
                    <path fill="#9fa8da" d="M11 24L25 2 39 24 25 32z" />
                    <path fill="#7986cb" d="M25 2L39 24 25 32z" />
                    <path fill="#9fa8da" d="M11 27L25 35 39 27 25 46z" />
                    <path
                      fill="#7986cb"
                      d="M25 35L39 27 25 46zM11 24L25 18 39 24 25 32z"
                    />
                    <path fill="#5c6bc0" d="M25 18L39 24 25 32z" />
                  </svg>
                </i>{" "}
                {truncate(address, 12)}
              </span>
            </span>
          </span>
          <span className="log-out" title="Disconnect">
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.655 8.9671C11.7526 8.86947 11.9109 8.86947 12.0085 8.9671L12.9445 9.90306C12.9914 9.94994 13.0177 10.0135 13.0177 10.0798C13.0177 10.1461 12.9914 10.2097 12.9445 10.2566L11.613 11.5881H19.1133C19.2514 11.5881 19.3633 11.7 19.3633 11.8381V13.1617C19.3633 13.2998 19.2514 13.4117 19.1133 13.4117H11.6132L12.9445 14.743C12.9914 14.7899 13.0177 14.8535 13.0177 14.9198C13.0177 14.9861 12.9914 15.0497 12.9445 15.0966L12.0085 16.0325C11.9616 16.0794 11.8981 16.1057 11.8318 16.1057C11.7655 16.1057 11.7019 16.0794 11.655 16.0325L8.76703 13.1446C8.41094 12.7885 8.41094 12.2111 8.76703 11.8551L11.655 8.9671Z"
                fill="#5A6277"
              ></path>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.25 6.5L6.25 6.5L6.25 18.5L14.25 18.5V20.5H6.25H5.25H4.25L4.25 4.5H5.25H6.25H14.25V6.5Z"
                fill="#5A6277"
              ></path>
            </svg>
          </span>
        </p>
      </Button>
    </aside>
  );
};
